
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavyRainShowersDayColour as ObiLightningHeavyRainShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-rain-showers-day-colour.js';
 
 
 

 
 export const ObiLightningHeavyRainShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-rain-showers-day-colour',
   elementClass: ObiLightningHeavyRainShowersDayColourElement,
   events: {
     
   }
  });
 
 